const ALLOWED_LINK_PROTOCOLS = ['http:', 'https:', 'mailto:', 'tel:'];

const BLOCKED_HREF = '#';

export function toSafeHref(url: string | null | undefined): string {
  try {
    const parsed = new URL(url ?? '');
    return ALLOWED_LINK_PROTOCOLS.includes(parsed.protocol)
      ? (url ?? '').trim()
      : BLOCKED_HREF;
  } catch {
    return BLOCKED_HREF;
  }
}
